import { getApp } from '@angular/fire/app';
import { Auth } from '@angular/fire/auth';
import {
  browserPopupRedirectResolver,
  connectAuthEmulator,
  indexedDBLocalPersistence,
  initializeAuth,
} from 'firebase/auth';
import { environment } from '../../environments/environment';

/**
 * Build Auth with IndexedDB persistence (and the local emulator) before any
 * onAuthStateChanged listener, router guard, or other Auth API runs.
 * Firebase requires both of those to be configured at initialize-time.
 */
export function initializePortalAuth(): Auth {
  const auth = initializeAuth(getApp(), {
    persistence: indexedDBLocalPersistence,
    popupRedirectResolver: browserPopupRedirectResolver,
  });
  if (environment.env === 'local') {
    connectAuthEmulator(auth, 'http://localhost:9099', {
      disableWarnings: true,
    });
  }
  return auth;
}
